/**
 * Query string builder for the OCR Scope Work API.
 */
export default class OCRScopeWorkQueryStringBuilder {
  archivedStatus?: boolean = false
  statusNames?: OCRScopingStatusNameFilterOptions[] = undefined

  /**
   * Filter by archived status.
   * @returns
   * @param archivedStatus
   */
  withArchivedStatus(archivedStatus: boolean): OCRScopeWorkQueryStringBuilder {
    if (archivedStatus === undefined) {
      return this
    }
    this.archivedStatus = archivedStatus
    return this
  }

  /**
   * Filter by status names.
   * @returns
   * @param statusNames
   */
  withStatusNames(
    statusNames: OCRScopingStatusNameFilterOptions[],
  ): OCRScopeWorkQueryStringBuilder {
    if (statusNames === undefined) {
      return this
    }
    this.statusNames = statusNames
    return this
  }

  /**
   * Builds the query string.
   *
   * @returns
   */
  build(): string {
    const queryParts = []

    if (this.archivedStatus !== undefined) {
      queryParts.push(`archived:${this.archivedStatus}`)
    }

    if (this.statusNames !== undefined) {
      queryParts.push(`status_name:${this.statusNames.join(';')}`)
    }

    return queryParts.join(',')
  }
}

export enum OCRScopingStatusNameFilterOptions {
  COMPLETED = 'Completed',
  READY_TO_SUBMIT = 'Ready to submit',
  SCOPING_IN_PROGRESS = 'Scoping in progress',
  REVIEW_REQUIRED = 'Review required',
  REVIEW_SUGGESTED = 'Review suggested',
  ERROR_OCCURRED = 'Error occurred',
}
